import { SERVER_URL } from "../../api";
import axios from 'axios'
import { getHeaderWithToken } from "../../helpers/func";
export const DELETE_IMAGE_REQUEST = 'DELETE_IMAGE_REQUEST';
export const DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS';
export const DELETE_IMAGE_ERROR = 'DELETE_IMAGE_ERROR';
export const RESET_DELETE_IMAGE = 'RESET_DELETE_IMAGE';


export const deleteImage = (id, data) => {
    let headers = getHeaderWithToken();
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: DELETE_IMAGE_REQUEST
            })
            axios({
                method: 'DELETE',
                url: `${SERVER_URL}v1/pattern/image`,
                headers: headers,
                data: { id, data }
            }).then(function (response) {
                dispatch({
                    type: DELETE_IMAGE_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: DELETE_IMAGE_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })

    }
}



